export default "__VITE_ASSET__DtboVlkq__"